import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function MyDay() {
  const { user } = useAuth();
  const [opps, setOpps] = useState([]);
  const [queue, setQueue] = useState({ floor: [], phone: [] });

  useEffect(() => {
    (async () => {
      const [o, q] = await Promise.all([
        api.get("/opportunities", { params: { active_only: false } }),
        api.get("/queue"),
      ]);
      setOpps(o.data.filter(x => x.salesperson_id === user?.user_id));
      setQueue(q.data);
    })();
  }, [user]);

  const myFloor = queue.floor.find(q => q.user_id === user?.user_id);
  const myPhone = queue.phone.find(q => q.user_id === user?.user_id);
  const today = opps.filter(o => new Date(o.started_at).toDateString() === new Date().toDateString());
  const closed = today.filter(o => o.outcome);
  const sold = today.filter(o => o.outcome === "sold");

  return (
    <Layout>
      <div className="p-4 md:p-8 max-w-4xl mx-auto">
        <div className="border-b border-white/10 pb-3 mb-6">
          <h1 className="font-display text-4xl font-black uppercase tracking-tight">{user?.display_name || user?.name}</h1>
          <p className="text-xs uppercase tracking-[0.3em] text-white/40 mt-1">My Day</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
          <div className="bg-[#141414] border border-white/10 p-4 rounded-sm">
            <div className="text-[10px] uppercase tracking-[0.25em] text-white/40">Floor Position</div>
            <div className="font-display tabular font-black text-5xl text-[#34C759]">{myFloor?.position || "—"}</div>
          </div>
          <div className="bg-[#141414] border border-white/10 p-4 rounded-sm">
            <div className="text-[10px] uppercase tracking-[0.25em] text-white/40">Phone Position</div>
            <div className="font-display tabular font-black text-5xl text-[#007AFF]">{myPhone?.position || "—"}</div>
          </div>
          <div className="bg-[#141414] border border-white/10 p-4 rounded-sm">
            <div className="text-[10px] uppercase tracking-[0.25em] text-white/40">Opps Today</div>
            <div className="font-display tabular font-black text-5xl">{today.length}</div>
          </div>
          <div className="bg-[#141414] border border-white/10 p-4 rounded-sm">
            <div className="text-[10px] uppercase tracking-[0.25em] text-white/40">Sold</div>
            <div className="font-display tabular font-black text-5xl text-[#34C759]">{sold.length}</div>
          </div>
        </div>

        <h2 className="font-display text-2xl font-black uppercase tracking-wider mb-3 border-b border-white/10 pb-2">My Opportunities</h2>
        <div className="space-y-2">
          {today.map(o => (
            <div key={o.opp_id} className="bg-[#141414] border border-white/10 p-3 rounded-sm flex items-center gap-3">
              <span className="text-[10px] uppercase tracking-widest font-bold text-[#34C759] w-20">{o.type.replace("_", " ")}</span>
              <span className="font-display font-bold uppercase flex-1 truncate">{o.customer_name || "Unnamed"}</span>
              <span className="text-xs text-white/50 truncate">{o.vehicle_of_interest || "—"}</span>
              <span className="text-[10px] uppercase tracking-widest font-bold" style={{ color: o.outcome ? "#34C759" : "#FFCC00" }}>
                {o.outcome || "open"}
              </span>
            </div>
          ))}
          {!today.length && <div className="text-white/30 italic text-sm py-6 text-center">No opportunities yet today.</div>}
        </div>
      </div>
    </Layout>
  );
}
